/*
 * This component is called by <Navbar />
 */
import React, { useEffect }                  from 'react'
import axios                                 from 'axios'
import { node_server }                       from '../Helpers'
import PropTypes                             from 'prop-types'

const DoesUserHaveABioComponent = ({doesUserHaveABioReport, signedInUserId}) => {


   useEffect( () => {
      if (signedInUserId > 9) {
         axios.get(node_server + `bio/DoesUserHaveABio/${signedInUserId}`)
         .then( res => res.data )
         .then( data => {
            doesUserHaveABioReport(data.hasABio)
         } )
      }
   }, [doesUserHaveABioReport, signedInUserId] )

   return (
      <div>
         
      </div>
   )
}

DoesUserHaveABioComponent.propTypes = {
   doesUserHaveABioReport: PropTypes.func,
   signedInUserId: PropTypes.number
}

export default DoesUserHaveABioComponent
